import React, { useMemo } from "react";
import { Alert, Button, Card, Descriptions, Space } from "antd";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import PermissionTagGroup from "../../components/PermissionTagGroup";
import { SUB_ACCOUNT_PERMISSION_ORDER } from "../../utils/permission";
import styles from "./index.modules.less";

const MyPermissions = () => {
  const permission = useSelector((state) => state.permission);
  const navigate = useNavigate();

  const unauthorizedModules = useMemo(() => {
    const authorized = Array.isArray(permission.authorizedModules) ? permission.authorizedModules : [];
    return SUB_ACCOUNT_PERMISSION_ORDER.filter((code) => !authorized.includes(code));
  }, [permission.authorizedModules]);

  return (
    <div className={styles.page}>
      <Card
        title={
          <Space size={12} align="center">
            <Button type="link" onClick={() => navigate(-1)}>
              <LeftOutlined />返回
            </Button>
            <span>我的权限</span>
          </Space>
        }
      >
        <Alert
          className={styles.notice}
          type="info"
          showIcon
          message="如需开通未授权模块，请联系主账号管理员处理。"
        />
        <Descriptions bordered column={1}>
          <Descriptions.Item label="当前账号">
            {permission.currentIdentity?.accountDisplay || "--"}
          </Descriptions.Item>
          <Descriptions.Item label="所属厂商">
            {permission.vendorName || "--"}
          </Descriptions.Item>
          <Descriptions.Item label="当前身份">
            {permission.identityType === "owner" ? "主账号" : permission.identityType === "sub_account" ? "子账号" : "--"}
          </Descriptions.Item>
          <Descriptions.Item label="已授权模块">
            <PermissionTagGroup permissions={permission.authorizedModules} scope="sub_account" />
          </Descriptions.Item>
          <Descriptions.Item label="未授权模块">
            <PermissionTagGroup permissions={unauthorizedModules} showUnauthorized scope="sub_account" />
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default MyPermissions;
